import { Theme } from "@emotion/react";
import {
    Globe24Icon,
    Group24Icon,
    Lock24Icon,
    NoAccess24Icon,
    Unlock24Icon,
    Visible24Icon,
} from "@kaltura/ds-react-icons";
import React from "react";
import { menuItemClasses } from "@mui/material";

export const getMenuProps = (theme: Theme) => {
    return {
        PaperProps: {
            style: {
                width: 363,
                backgroundColor: theme.kaltura.palette.tone8,
            },
        },
        anchorOrigin: {
            vertical: "bottom" as const,
            horizontal: "left" as const,
        },
        transformOrigin: {
            vertical: "top" as const,
            horizontal: "left" as const,
        },
        MenuListProps: {
            sx: {
                [`& .${menuItemClasses.root}.${menuItemClasses.selected}`]: {
                    backgroundColor: "initial !important", // won't work without !important
                    "& > div": {
                        backgroundColor: theme.kaltura.palette.tone6,
                    },
                },
            },
        },
    };
};

// map icons names to icons components, used in the privacy select field
export const iconMap: Record<string, React.ComponentType> = {
    Globe24Icon,
    NoAccess24Icon,
    Lock24Icon,
    Group24Icon,
    Unlock24Icon,
    Visible24Icon,
};
